// Older DingTalk WebViews support AbortController but not AbortSignal.timeout.
export async function withLoginTimeout<T>(request: (signal: AbortSignal) => Promise<T>, timeoutMs = 20000): Promise<T> {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);
  try {
    return await request(controller.signal);
  } catch (error) {
    if (controller.signal.aborted) throw new Error('钉钉登录响应超时，请重试');
    throw error;
  } finally {
    clearTimeout(timer);
  }
}
